// @flow

import React from "react";
import { compose, withHandlers, withState } from "recompose";

import { Translate, withI18n } from "@quantum/i18n";
import { Modal, OkButton, withModal } from "@quantum/ui";

import "./save-group-modal.css";

type Props = {
  onSaveGroup: string => any,
};

type EnhancedProps = {
  groupName: string,
  show: boolean,
  onHide: Function,
  onGroupNameChange: Function,
  onSubmit: Function,
};

const enhance = compose(
  withModal("saveAssetGroup"),

  withI18n,
  withState("groupName", "setGroupName", ({ translate }) =>
    translate("Comum.Novo.Grupo")
  ),

  withHandlers({
    onGroupNameChange: ({ setGroupName }) => event =>
      setGroupName(event.target.value),
    onHide: ({ setGroupName, onHide, translate }) => () => {
      setGroupName(translate("Comum.Novo.Grupo"));
      onHide();
    },
    onSubmit: ({ groupName, onSaveGroup, onHide }) => event => {
      event.preventDefault();
      onSaveGroup({ name: groupName });
      onHide();
    },
  })
);

const SaveGroupModal = ({
  groupName,
  show,
  onGroupNameChange,
  onHide,
  onSubmit,
}: Props & EnhancedProps) => (
  <Modal
    className="SaveGroupModal"
    header={
      <div className="SaveGroupModal__header">
        <h1 className="SaveGroupModal__title">
          <Translate>Arquivo.Salvar.Selecao.Como.Novo.Grupo</Translate>
        </h1>
      </div>
    }
    show={show}
    onHide={onHide}
  >
    <form className="SaveGroupModal__form" onSubmit={onSubmit}>
      <label className="SaveGroupModal__label">
        <Translate>Arquivo.SalvarComo</Translate>
      </label>
      <div className="SaveGroupModal__input-wrapper">
        <input
          className="SaveGroupModal__input"
          onChange={onGroupNameChange}
          value={groupName}
        />
        <OkButton className="SaveGroupModal__submit">
          <Translate>Comum.Ok</Translate>
        </OkButton>
      </div>
    </form>
  </Modal>
);

export default enhance(SaveGroupModal);
